import { render, staticRenderFns } from "./PopupAccountAlert.vue?vue&type=template&id=0bc82151"
import script from "./PopupAccountAlert.vue?vue&type=script&lang=js"
export * from "./PopupAccountAlert.vue?vue&type=script&lang=js"
import style0 from "./PopupAccountAlert.vue?vue&type=style&index=0&id=0bc82151&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports